import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import DebtDetail from '../DebtDetail';
import apiClient from "../../axios";
import SuccessNotification from "../../components/Notifications/SuccessNotification";
import ErrorNotification from "../../components/Notifications/ErrorNotification";
import LoginNotification from "../../components/Notifications/LoginNotification";
import Loader from "../Loader";

const DebtModal = ({ message, isVisible, onClose, code }) => {

    const [loading, setLoading] = useState(false);
    const [isInfoVisible, setIsInfoVisible] = useState(false);
    const [isSuccessVisible, setIsSuccessVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [modalDeatil, setDetail] = useState(false);
    const [cuponCredit, setCuponCredit] = useState("");
    const [debt, setDebt] = useState("");

    useEffect(() => {
        const fetchDetail = async () => {
            try {
                setLoading(true);
                const response = await apiClient.get(`/distributors/${code}/debt`);
                setCuponCredit(response.data.cuponCredit);
                setDebt(response.data.debt);

            } catch (error) {
                setIsErrorVisible(true);
                if (error.response && error.response.status === 401) {
                    setIsInfoVisible(true);
                }
            }
            finally {
                setLoading(false);
                setIsErrorVisible(false);
                setIsSuccessVisible(false);
            }
        };
        fetchDetail();
    }, [code]);

    const handleViewDetail = () => {
        setDetail(true);
    };

    const handleCloseSuccess = () => {
        onClose();
    };

    return (
        isVisible && (
            <div className="info-notification-info-overlay">
                <div className="info-notification-info">
                    <div className="icon-container-noti-info">
                        <FontAwesomeIcon icon={faCircleInfo} className="icon-noti2" />
                    </div>
                    <div className="message-container-info">
                        <h4>No se puede crear Contarto</h4>
                        <p>
                            El distribuidor {code} tiene un Cupo de Crédito de ${cuponCredit} y una Deuda de ${debt}
                        </p>
                    </div>
                    <div className="button-container-info">
                        <button className="ok-btn-info" onClick={onClose}>
                            OK
                        </button>
                        <button className="ok-btn-info" onClick={handleViewDetail}>
                            Ver Detalles
                        </button>
                    </div>


                </div>
                {modalDeatil && (
                    <div className="modal-overlay-edit">
                        <div className="modal-content-edit">
                            <DebtDetail code={code} closeModal={handleCloseSuccess} />
                        </div>
                    </div>
                )}

                {loading && <Loader />}
                <SuccessNotification
                    message={"Se ha cargado correctamente"}
                    isVisible={isSuccessVisible}
                    onClose={() => setIsSuccessVisible(false)}
                />
                <ErrorNotification
                    message="Ups! Verifique los datos enviados."
                    isVisible={isErrorVisible}
                    onClose={() => setIsErrorVisible(false)}
                />

                <LoginNotification
                    message="Vuele a iniciar sesión"
                    isVisible={isInfoVisible}
                    onClose={() => setIsInfoVisible(false)}
                />
            </div>

        )
    );
};

export default DebtModal;
